import "../css/style.scss"

// Our modules / classes
//import MobileMenu from "./modules/MobileMenu"
import HeroSlider from "./modules/HeroSlider"
//import GoogleMap from "./modules/GoogleMap"
//import Search from "./modules/search" 

// Instantiate a new object using our modules/classes
//var mobileMenu = new MobileMenu()
var heroSlider = new HeroSlider()
//const googleMap = new GoogleMap()
//const searchClass   = new Search()